import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { initCookieConsent } from "@/lib/cookieConsent";
import { initTheme } from "@/lib/theme";

Sentry.init({
  dsn: "https://6e90ac0c90321c769ba4e5bb7f270b75@o4511140794269696.ingest.us.sentry.io/4511140796628992",
  tracesSampleRate: 0.1,
  enabled: import.meta.env.PROD,
  // Browser-extension noise: anti-fingerprint / antivirus content scripts inject a
  // message channel that rejects with "Object Not Found Matching Id:N, MethodName:...".
  // It has no frames into our bundle and no user impact — drop it before it becomes an issue.
  ignoreErrors: ["Object Not Found Matching Id"],
});

// The boot script in index.html has already stamped <html>; this arms the
// cross-tab sync and covers any entry that skipped the script.
initTheme();

// Loads the consent banner, which is what starts analytics — nothing is captured and no
// analytics cookie is written until a visitor opts in.
initCookieConsent();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
